export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-3.723f4089.png";